/**
 * 선물상자 허브 UI 상수/메시지 키 — 독립 모듈
 * 실제 문구는 언어팩(i18n)에서 관리.
 */
export const GIFTBOX_HUB_KEYS = {
  TITLE: 'giftbox_hub_title',
  TODAY_COUNT: 'giftbox_hub_today_count',
  EXPIRES_AT: 'giftbox_hub_expires_at',
  OPEN_BASIC: 'giftbox_hub_open_basic',
  OPEN_AD: 'giftbox_hub_open_ad',
  GO_WALK: 'giftbox_hub_go_walk',
  NORMAL_LABEL: 'giftbox_hub_normal',
  LANDMARK_LABEL: 'giftbox_hub_landmark',
  COLLECT_SUCCESS: 'giftbox_collect_success',
  OPEN_SUCCESS: 'giftbox_claim_success',
  NO_BOX: 'giftbox_no_box',
  WAITING: 'giftbox_waiting',
  WALK_TIP: 'giftbox_walk_tip',
  WALK_CTA: 'giftbox_walk_cta',
  RESET_IN: 'giftbox_hub_reset_in',
  LOGIN_REQUIRED: 'spot_login_required',
  DAILY_LIMIT: 'giftbox_daily_limit',
  OPEN_DESC_NORMAL: 'giftbox_hub_open_desc_normal',
  OPEN_DESC_NORMAL: 'giftbox_hub_open_desc_normal',
  OPEN_DESC_ALL: 'giftbox_hub_open_desc_all',
  SPEED_LIMIT_MSG: 'giftbox_speed_limit_reached'
};

export const DAILY_NORMAL_LIMIT = 10;
export const DAILY_LANDMARK_LIMIT = 10;
